export default function initLandingPageForm() {
    // The "Go to form" bar links to whichever form the page shows: the original one or a Forms form.
    const mobileCta = document.getElementById('landing-page-mobile-cta');
    const ctaTarget = mobileCta && document.querySelector(mobileCta.getAttribute('href'));
    if (ctaTarget && 'IntersectionObserver' in window) {
        const formObserver = new IntersectionObserver(([entry]) => {
            mobileCta.classList.toggle('hidden', entry.isIntersecting);
        }, {
            threshold: 0.1
        });
        formObserver.observe(ctaTarget);
    }

    // Get the original form and return early if the page uses a Forms form instead
    const form = document.getElementById('landing-page-form');
    if (!form) return;

    // Get required elements
    const submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton) {
        console.warn('Submit button not found');
        return;
    }

    // Check if reCAPTCHA has loaded
    let captchaLoaded = false;

    // Ensure recaptcha_response input exists
    let recaptchaInput = document.getElementById('landing_recaptcha_response');
    if (!recaptchaInput) {
        recaptchaInput = document.createElement('input');
        recaptchaInput.type = 'hidden';
        recaptchaInput.id = 'landing_recaptcha_response';
        recaptchaInput.name = 'recaptcha_response';
        form.appendChild(recaptchaInput);
    }

    // Lazy-load reCAPTCHA
    function loadRecaptcha() {
        if (captchaLoaded) return;
        captchaLoaded = true;

        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=6LcXEcsbAAAAACI79HkuXwvBm-ap6pOItplTXoZ5';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }

    // Attach listeners to form fields to trigger reCAPTCHA load
    const inputs = form.querySelectorAll('input, textarea');
    inputs.forEach(input => {
        input.addEventListener('focus', loadRecaptcha, { once: true });
    });

    // Form Submit Handler
    form.addEventListener('submit', async function(e) {
        e.preventDefault();

        // Verify that our AJAX object is configured
        if (typeof ajax_object === 'undefined' || !ajax_object.ajax_url) {
            showErrorMessage('Configuration error. Please try again later.');
            return;
        }

        // Store original button text for resetting
        const originalButtonText = submitButton.textContent;
        
        // Update button state
        submitButton.textContent = 'Submitting...';
        submitButton.disabled = true;

        // Make sure reCAPTCHA is loaded
        if (!captchaLoaded || typeof grecaptcha === 'undefined') {
            showErrorMessage('Security verification not initialized. Please try again.');
            resetButtonState(originalButtonText);
            return;
        }

        // Execute reCAPTCHA
        grecaptcha.ready(async function() {
            try {
                const token = await grecaptcha.execute('6LcXEcsbAAAAACI79HkuXwvBm-ap6pOItplTXoZ5', { action: 'submit' });
                recaptchaInput.value = token;

                // Now submit the form via AJAX
                await submitForm(originalButtonText);
            } catch (error) {
                console.error('reCAPTCHA error:', error);
                showErrorMessage('An error occurred while verifying security. Please try again.');
                resetButtonState(originalButtonText);
            }
        });
    });

    // Actual Submit via AJAX
    async function submitForm(originalButtonText) {
        // Collect all form data
        const formData = new FormData(form);
        formData.append('action', 'landing_page_submission');

        // Get landing page info from data attributes
        const landingPageId = form.dataset.landingPageId || '';
        const landingPageSlug = form.dataset.landingPageSlug || '';
        const landingPageTitle = form.dataset.landingPageTitle || '';
        
        formData.append('landing_page_id', landingPageId);
        formData.append('landing_page_slug', landingPageSlug);
        formData.append('landing_page_title', landingPageTitle);

        try {
            const response = await fetch(ajax_object.ajax_url, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin'
            });

            const result = await response.json();

            if (result.success) {
                const successMessage = form.dataset.successMessage
                    || result.data
                    || 'Thank you for your interest! We will be in touch soon.';
                showSuccessMessage(successMessage);
                form.reset();
            } else {
                const errorMsg = result.data || 'An error occurred. Please try again.';
                showErrorMessage(errorMsg);
            }
        } catch (error) {
            console.error('Submission error:', error);
            showErrorMessage('Network error. Please check your connection and try again.');
        } finally {
            resetButtonState(originalButtonText);
        }
    }

    // Helper: Reset Button State
    function resetButtonState(originalText) {
        submitButton.textContent = originalText;
        submitButton.disabled = false;
    }

    // Helper: Show Success Message
    function showSuccessMessage(message) {
        // Remove any existing messages
        const existingMessages = form.querySelectorAll('.form-message');
        existingMessages.forEach(msg => msg.remove());

        const messageDiv = document.createElement('div');
        messageDiv.className = 'form-message success-message p-4 bg-green-100 text-green-800 rounded-sm mb-4';
        messageDiv.textContent = message;
        form.insertBefore(messageDiv, form.firstChild);

        // Scroll to message
        messageDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // Helper: Show Error Message
    function showErrorMessage(message) {
        // Remove any existing messages
        const existingMessages = form.querySelectorAll('.form-message');
        existingMessages.forEach(msg => msg.remove());

        const messageDiv = document.createElement('div');
        messageDiv.className = 'form-message error-message p-4 bg-red-100 text-red-800 rounded-sm mb-4';
        messageDiv.textContent = message;
        form.insertBefore(messageDiv, form.firstChild);

        // Scroll to message
        messageDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}


